import React from 'react';
import { BookOpenIcon, CalendarIcon, CheckCircleIcon, ClockIcon, MonitorIcon, UserIcon, UsersIcon } from 'lucide-react';
import { WebinarLink } from './WebinarLink';
export const WebinarDetails = ({
  openModal
}) => {
  const replaceWebinarWithLink = text => {
    const parts = text.split(/(\bwebinar\b)/i);
    return parts.map((part, index) => {
      if (part.toLowerCase() === 'webinar') {
        return <WebinarLink key={index} onClick={openModal} data-id="element-414">
            webinar
          </WebinarLink>;
      }
      return part;
    });
  };
  return <section className="mb-10" data-id="element-415">
      <h2 className="text-xl font-bold text-blue-800 mb-4 flex items-center" data-id="element-416">
        <UserIcon className="w-6 h-6 mr-2 text-blue-600" data-id="element-417" />
        De trainer die Mech's waarheid omarmt
      </h2>
      <div className="flex items-start mb-6" data-id="element-418">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kJ5b6tBbH8hDNt52JG84mT/Scherm%C2%ADafbeelding_2025-08-15_om_15.44.02.png" alt="Amee de Bruijn" className="w-24 h-24 rounded-full object-cover mr-4 flex-shrink-0" data-id="element-419" />
        <div data-id="element-420">
          <p className="mb-4 leading-relaxed" data-id="element-421">
            Amee de Bruijn werd eerst traditioneel opgeleid. Totdat ze David
            Mech's latere uitspraken ontdekte.
          </p>
          <p className="mb-4 leading-relaxed" data-id="element-422">
            "Ik voelde me bedonderd door de industrie," vertelt Amee. "Veel van
            wat ze je tijdens een standaar opleiding leren, is gebaseerd op
            wetenschap die de oorspronkelijke onderzoeker zelf heeft afgekeurd."
          </p>
          <p className="leading-relaxed" data-id="element-423">
            Als gediplomeerd hondengedragsconsultant ontwikkelde Amee methoden
            gebaseerd op echte wetenschap: "Van domineren, straffen en
            corrigeren naar echt elkaar begrijpen en samenwerken met je hond."
          </p>
        </div>
      </div>
      <p className="mb-6 leading-relaxed italic border-l-4 border-blue-300 pl-4" data-id="element-424">
        Een van haar clienten uit Utrecht schrijft: "Super fijne training om
        andere inzichten te krijgen in honden dan dat gebruikelijke
        hondenscholen geven. Op een zachtere manier met je hond om gaan i.p.v.
        dominant zijn. Dit sluit beter aan bij wie ik ben."
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-425">
        Inmiddels heeft Amee 15.000+ Nederlandse en Vlaamse hondeneigenaren
        geholpen. In 2025 leerden al meer dan 100.000+ mensen de werkelijke
        feiten kennen via{' '}
        <a href="https://stresslessdogs.nl/meta-mcc-adv" className="text-blue-600 cursor-pointer hover:underline" target="_blank" rel="noopener noreferrer" onClick={openModal} data-id="element-426">
          haar populaire online webinar
        </a>
        .
      </p>
      <h3 className="text-lg font-bold text-blue-800 mb-4 mt-8" data-id="element-427">
        Wat is een webinar?
      </h3>
      <p className="mb-6 leading-relaxed" data-id="element-428">
        Een webinar is een online presentatie die je live kunt volgen vanaf je
        telefoon, tablet of computer. Je hoeft nergens naartoe te reizen - je
        volgt gewoon thuis, op kantoor of onderweg via een internetverbinding.
        Tijdens het webinar kun je via de chat vragen stellen aan Amee, en na
        afloop ontvang je automatisch de opname zodat je alles terug kunt kijken
        wanneer het jou uitkomt.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-429">
        Amee geeft deze week het webinar nog een aantal keer en er zijn een
        beperkt aantal plekken.{' '}
        <a href="https://stresslessdogs.nl/meta-mcc-adv" className="text-blue-600 cursor-pointer hover:underline" target="_blank" rel="noopener noreferrer" onClick={openModal} data-id="element-430">
          Hier kan je zien of er nog plek is.
        </a>
      </p>
      <h2 className="text-xl font-bold text-blue-800 mb-4 flex items-center" data-id="element-431">
        <MonitorIcon className="w-6 h-6 mr-2 text-blue-600" data-id="element-432" />
        Wat Amee tijdens het webinar vertelt
      </h2>
      <div className="space-y-4 mb-8" data-id="element-433">
        <div className="flex" data-id="element-434">
          <div className="bg-blue-600 text-white rounded-full min-w-8 h-8 flex items-center justify-center font-bold mr-3" data-id="element-435">
            1
          </div>
          <div data-id="element-436">
            <h4 className="font-bold" data-id="element-437">
              Minuut 1-20: Waarom Mech zijn dominantie theorie afkeurde
            </h4>
            <p className="text-sm text-gray-700" data-id="element-438">
              Waarom de grondlegger van dominantie-training zegt dat je zijn
              methode niet moet gebruiken, en hoe wolven in gevangenschap een
              verkeerd beeld gaven.
            </p>
          </div>
        </div>
        <div className="flex" data-id="element-439">
          <div className="bg-blue-600 text-white rounded-full min-w-8 h-8 flex items-center justify-center font-bold mr-3" data-id="element-440">
            2
          </div>
          <div data-id="element-441">
            <h4 className="font-bold" data-id="element-442">
              Minuut 21-35: Hoe honden natuurlijk communiceren
            </h4>
            <p className="text-sm text-gray-700" data-id="element-443">
              Je ontdekt hoe honden in de natuur onderling communiceren en welke
              signalen ze gebruiken - compleet anders dan wolven.
            </p>
          </div>
        </div>
        <div className="flex" data-id="element-444">
          <div className="bg-blue-600 text-white rounded-full min-w-8 h-8 flex items-center justify-center font-bold mr-3" data-id="element-445">
            3
          </div>
          <div data-id="element-446">
            <h4 className="font-bold" data-id="element-447">
              Minuut 36-55: Signalen herkennen en interpreteren
            </h4>
            <p className="text-sm text-gray-700" data-id="element-448">
              Je leert de belangrijkste lichaamstaal-signalen die elke hond
              gebruikt, en wat ze werkelijk betekenen in verschillende
              situaties.
            </p>
          </div>
        </div>
        <div className="flex" data-id="element-449">
          <div className="bg-blue-600 text-white rounded-full min-w-8 h-8 flex items-center justify-center font-bold mr-3" data-id="element-450">
            4
          </div>
          <div data-id="element-451">
            <h4 className="font-bold" data-id="element-452">Minuut 56-75: In hun taal terugpraten</h4>
            <p className="text-sm text-gray-700" data-id="element-453">
              Hoe je terugcommuniceert in hun taal en wat dit betekent voor
              jullie dagelijkse samenwerking.
            </p>
          </div>
        </div>
        <div className="flex" data-id="element-454">
          <div className="bg-blue-600 text-white rounded-full min-w-8 h-8 flex items-center justify-center font-bold mr-3" data-id="element-455">
            5
          </div>
          <div data-id="element-456">
            <h4 className="font-bold" data-id="element-457">Minuut 76-90: Vraag-en-antwoord</h4>
            <p className="text-sm text-gray-700" data-id="element-458">
              Amee beantwoordt vragen van deelnemers en onthult een speciale
              bonus.
            </p>
          </div>
        </div>
      </div>
      <p className="mb-6 leading-relaxed" data-id="element-459">
        "Rond minuut 20 valt het kwartje," vertelt Amee. "Wanneer ik een aantal
        misvattingen over dominantie uit de wereld help, zie ik in de chat dat
        mensen plotseling begrijpen waarom hun aanpak niet werkte."
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-460">
        <a href="https://stresslessdogs.nl/meta-mcc-adv" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer" data-id="element-461">
          Klik hier om jezelf aan te melden voor het webinar.
        </a>
      </p>
      <div className="bg-blue-50 p-6 rounded-lg mb-8 border border-blue-200" data-id="element-462">
        <div className="flex items-center mb-4" data-id="element-463">
          <CalendarIcon className="w-5 h-5 text-blue-600 mr-2" data-id="element-464" />
          <h3 className="font-bold" data-id="element-465">Dit webinar kan snel volgeboekt zijn</h3>
        </div>
        <p className="mb-4 leading-relaxed" data-id="element-466">
          Ik moet eerlijk tegen je zijn - de vraag naar deze informatie is
          gewoon enorm.
        </p>
        <p className="mb-4 leading-relaxed" data-id="element-467">
          Sinds David Mech's onthullingen meer bekend worden, melden zich elke
          week meer baasjes aan die eindelijk de waarheid willen weten.
        </p>
        <p className="mb-4 leading-relaxed" data-id="element-468">
          Het probleem is dat elk webinar maximaal 75 plekken heeft. En als alle
          plekken vol zijn? Dan kan ik pas volgende maand nieuwe sessies
          organiseren.
        </p>
        <div className="bg-white p-4 rounded-lg border border-blue-200 mb-5" data-id="element-469">
          <p className="font-bold text-blue-800 mb-2" data-id="element-470">
            Dit kan je enige kans zijn:
          </p>
          <p className="text-blue-800" data-id="element-471">
            Het organiseren van deze gratis webinars kost me enorm veel tijd en
            energie. Ik kan niet garanderen wanneer ik weer een reeks volgende
            gratis sessies doe.
          </p>
        </div>
        <a href="https://stresslessdogs.nl/meta-mcc-adv" className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-4 rounded-lg transition duration-200 block text-center" target="_blank" rel="noopener noreferrer" data-id="element-472">
          JA, IK WIL DE WAARHEID WETEN - GRATIS AANMELDEN
        </a>
      </div>
      <div className="w-full mb-6" data-id="element-473">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4q5cC71mhLz2oJ2dhhpDRD/Scherm_afbeelding_2025-08-15_om_15.46.41-min.png" alt="Vrouw wandelt ontspannen met haar hond op een bospad" className="w-full h-auto rounded-lg shadow-md" data-id="element-474" />
        <p className="text-xs text-gray-500 mt-1 text-center italic" data-id="element-475">
          Een stressvrij leven voor je hond. En voor jou.
        </p>
      </div>
      <div className="bg-green-50 p-6 rounded-lg border border-green-200 mb-8" data-id="element-476">
        <h3 className="text-lg font-bold text-green-800 mb-4" data-id="element-477">
          Over het populaire webinar van Amee: "Communiceren met je hond"
        </h3>
        <ul className="space-y-3 mb-5" data-id="element-478">
          <li className="flex items-start" data-id="element-479">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-480" />
            <span data-id="element-481">Volledig gratis - geen verborgen kosten</span>
          </li>
          <li className="flex items-start" data-id="element-482">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-483" />
            <span data-id="element-484">Te volgen vanaf telefoon, tablet of computer</span>
          </li>
          <li className="flex items-start" data-id="element-485">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-486" />
            <span data-id="element-487">Opname wordt toegestuurd</span>
          </li>
          <li className="flex items-start" data-id="element-488">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-489" />
            <span data-id="element-490">Maximaal 75 plekken per sessie</span>
          </li>
          <li className="flex items-start" data-id="element-491">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-492" />
            <span data-id="element-493">
              Speciale verrassingsbonus tijdens het{' '}
              {replaceWebinarWithLink('webinar')}
            </span>
          </li>
        </ul>
        <p className="font-bold mb-5" data-id="element-494">Hoe krijg je toegang:</p>
        <ol className="list-decimal pl-8 mb-5 space-y-2" data-id="element-495">
          <li data-id="element-496">Klik de aanmeldbutton hieronder</li>
          <li data-id="element-497">Kies je tijdslot (vandaag of morgen)</li>
          <li data-id="element-498">Vul het korte aanmeldformulier in</li>
          <li data-id="element-499">Ontvang direct je toegangslink via email</li>
          <li data-id="element-500">
            Klik 5 minuten voor de start op de link in mail (het webinar start
            dan automatisch. Je hebt geen software nodig.)
          </li>
        </ol>
        <a href="https://stresslessdogs.nl/meta-mcc-adv" className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-4 rounded-lg transition duration-200 block text-center" target="_blank" rel="noopener noreferrer" data-id="element-501">
          JA, IK WIL DE WAARHEID WETEN - GRATIS AANMELDEN
        </a>
      </div>
    </section>;
};